import React from 'react';
import UrinEnergy from './UrinEnergy';

function App() {
  return (
    <div className="App">
      <UrinEnergy />
    </div>
  );
}

export default App;
